import { ACT_ENCOUNTER_CODES } from './CodingSystems.ts';
import type { InstrumentAnswer } from './Hl7Instruments.ts';

const { INPATIENT, AMBULATORY, EMERGENCY, PRE_ADMISSION, HOME_HEALTH } = ACT_ENCOUNTER_CODES;

/**
 * `hl7:patient-class` answers. Prefill seeds every `defaultInput`, so the set
 * covers the processor's built-in table (HL7 table 0004 plus the full-text
 * variants customers send) and adding an entry never drops a code that maps today.
 */
export const PATIENT_CLASS_ANSWERS: readonly InstrumentAnswer[] = [
  { output: INPATIENT, label: 'Inpatient', defaultInput: 'I' },
  { output: AMBULATORY, label: 'Outpatient', defaultInput: 'O' },
  { output: EMERGENCY, label: 'Emergency', defaultInput: 'E' },
  { output: PRE_ADMISSION, label: 'Preadmit', defaultInput: 'P' },
  { output: AMBULATORY, label: 'Recurring patient (ambulatory)', defaultInput: 'R' },
  { output: INPATIENT, label: 'Obstetrics (inpatient)', defaultInput: 'B' },
  { output: AMBULATORY, label: 'Not applicable (ambulatory)', defaultInput: 'N' },
  { output: INPATIENT, label: 'Inpatient (IP)', defaultInput: 'IP' },
  { output: INPATIENT, label: 'Inpatient (spelled out)', defaultInput: 'INPATIENT' },
  { output: AMBULATORY, label: 'Outpatient (spelled out)', defaultInput: 'OUTPATIENT' },
  { output: EMERGENCY, label: 'Emergency (spelled out)', defaultInput: 'EMERGENCY' },
  { output: HOME_HEALTH, label: 'Home health', defaultInput: 'HOME HEALTH' },
  { output: AMBULATORY, label: 'Hospital outpatient', defaultInput: 'HOSPITAL OUT' },
  { output: INPATIENT, label: 'Skilled nursing inpatient', defaultInput: 'SNF IP' },
  { output: AMBULATORY, label: 'Swing bed outpatient', defaultInput: 'SWING OUTPAT' },
  { output: INPATIENT, label: 'Swing bed inpatient', defaultInput: 'SWING INPATI' },
  { output: INPATIENT, label: 'Long-term acute care inpatient', defaultInput: 'INPT LTACH' },
  { output: INPATIENT, label: 'Psychiatric inpatient', defaultInput: 'INPT PSYCH' },
  { output: INPATIENT, label: 'Rehabilitation inpatient', defaultInput: 'INPT REHAB' },
  { output: ACT_ENCOUNTER_CODES.OBSERVATION, label: 'Observation' },
  { output: ACT_ENCOUNTER_CODES.INPATIENT_ACUTE, label: 'Inpatient acute' },
  { output: ACT_ENCOUNTER_CODES.INPATIENT_NON_ACUTE, label: 'Inpatient non-acute' },
  { output: ACT_ENCOUNTER_CODES.SHORT_STAY, label: 'Short stay' },
  { output: ACT_ENCOUNTER_CODES.VIRTUAL, label: 'Virtual' },
  { output: ACT_ENCOUNTER_CODES.FIELD, label: 'Field' }
];
